import { useEffect, useState } from 'react';
import { Portal } from '../../../components/Portal';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { getOrAddSandboxBannerContainerRoot } from '../../../utils/globalToolbarUtils';
import { getIsSandboxPortal } from '../api/cachedFetchers';
import { SANDBOX_BANNER_GATE } from '../constants/constants';
import { SandboxBanner } from './SandboxBanner';
import { selectShouldShowToolbar } from '../../../overlayDisplayConfig/selectors';
import { simpleErrorHandler } from '../../../errors/simpleErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
export const SandboxBannerMaybe = () => {
  const gates = useAppSelector(selectGates);
  const isUngatedForSandboxBannerRedesign = gates && gates.includes(SANDBOX_BANNER_GATE);
  const [isSandboxPortal, setIsSandboxPortal] = useState(false);
  const shouldShowGlobalToolbar = useAppSelector(selectShouldShowToolbar);
  useEffect(() => {
    if (isUngatedForSandboxBannerRedesign) {
      getIsSandboxPortal().then(isSandbox => {
        setIsSandboxPortal(isSandbox);
      }).catch(simpleErrorHandler('Failed to fetch sandbox portal status'));
    }
  }, [isUngatedForSandboxBannerRedesign]);
  if (isUngatedForSandboxBannerRedesign && isSandboxPortal && shouldShowGlobalToolbar) {
    return /*#__PURE__*/_jsx(Portal, {
      container: getOrAddSandboxBannerContainerRoot,
      children: /*#__PURE__*/_jsx(SandboxBanner, {})
    }, "rootNavSandboxBanner");
  }
  return null;
};